import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Typography,
  Paper,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';

import CheckCircle from '@material-ui/icons/CheckCircle';

import { formatMoney } from '../../../utils/common';
import { PIX_ENABLED } from '../../../consts/common';
import { useStyles } from './styles';
import { useStyles as useBaseStyles } from '../baseStyle';

function ContratarAbertura(props) {
  const classes = useStyles(props);
  const classesStylesBase = useBaseStyles(props);

  const history = useHistory();

  const [openChoosePayment, setOpenChoosePayment] = useState(false);

  const goToPayment = (route) => {
    history.push({
      pathname: route,
      state: {
        item: props.location.state.item,
        signaturePlan: props.location.state.signaturePlan,
        user: props.location.state.user,
        portal: props.location.state.portal,
      },
    });
  };

  const contratarServico = () => {
    if (!PIX_ENABLED) {
      goToPayment('/payment-card');
      return;
    }

    setOpenChoosePayment(true);
  };

  return (
    <Grid
      container
      spacing={0}
      alignItems="center"
      justifyContent="center"
      className={classesStylesBase.grid}
    >
      <Paper elevation={10} className={classesStylesBase.root}>
        <div className={classesStylesBase.logoContainer}>
          <img
            src="/logo-black.png"
            alt="Xmei Logo"
            className={classesStylesBase.logo}
          />
        </div>
        <Typography className={classes.header}>SERVIÇO</Typography>
        <Typography className={classes.title}>
          {props.location.state.item.nome}
        </Typography>
        <Card>
          <CardHeader subheader={props.location.state.item.descricao} />

          <CardContent>
            <div>
              <Typography className={classes.textDocumentRequired}>
                Documentação necessária:
              </Typography>
              {props.location.state.item.documentos_necessario_servicos?.map(
                (documento) => (
                  <div
                    key={documento.id_documento_necessario}
                    className={classes.viewImageDescription}
                  >
                    <Typography className={classes.textDocumentRequired}>
                      <CheckCircle htmlColor="green" className={classes.icon} />
                      {documento.DocumentoNecessario.nome}
                    </Typography>
                  </div>
                )
              )}
            </div>
          </CardContent>
        </Card>
        <Card style={{ width: '100%', marginTop: '20px' }}>
          <CardContent>
            <div className={classes.bodyValue}>
              <Typography
                style={{ display: 'block' }}
                className={classes.textValue}
              >
                SERVIÇO
              </Typography>
              <Typography style={{ display: 'block' }} className={classes.text}>
                {props.location.state.item.valor &&
                  formatMoney(props.location.state.item.valor)}
              </Typography>
            </div>
          </CardContent>
          <CardContent>
            <div className={classes.bodyValue}>
              <Typography
                style={{ display: 'block' }}
                className={classes.textValue}
              >
                ASSINATURA
              </Typography>
              <Typography style={{ display: 'block' }} className={classes.text}>
                {props.location.state.signaturePlan.valor &&
                  formatMoney(
                    parseFloat(props.location.state.signaturePlan.valor / 100)
                  )}
              </Typography>
            </div>
          </CardContent>
        </Card>
        <Card style={{ width: '100%', marginTop: '20px' }}>
          <CardContent>
            <div className={classes.bodyValue}>
              <Typography
                style={{ display: 'inline-block' }}
                className={classes.textValue}
              >
                TOTAL
              </Typography>
              <Typography
                style={{ display: 'inline-block' }}
                className={classes.text}
              >
                {props.location.state.signaturePlan.valor &&
                  formatMoney(
                    parseFloat(props.location.state.signaturePlan.valor / 100) +
                      props.location.state.item.valor
                  )}
              </Typography>
            </div>
          </CardContent>
        </Card>

        <Button
          type="button"
          variant="contained"
          fullWidth
          // disabled={!isValid}
          className={classes.submit}
          onClick={() => contratarServico()}
        >
          CONTRATAR
        </Button>

        <Dialog
          open={openChoosePayment}
          onClose={() => setOpenChoosePayment(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Escolha a forma de pagamento</DialogTitle>
          <DialogContent>
            <Typography>Selecione como deseja realizar o pagamento.</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenChoosePayment(false)}>
              Cancelar
            </Button>
            <Button
              color="primary"
              onClick={() => goToPayment('/payment-card')}
            >
              Cartão de Crédito
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => goToPayment('/payment-pix')}
            >
              Pix
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Grid>
  );
}

export default ContratarAbertura;
